import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Mail, FileText, FileCheck, Fingerprint } from 'lucide-react';

export const IntroSection = () => {
  return (
    <Card className="bg-gray-800/20 border-gray-700 text-white">
      <CardHeader>
        <CardTitle className="text-2xl">Willkommen zu Vibemail</CardTitle>
        <CardDescription className="text-gray-400">
          Die KI-gestützte Plattform für Versicherungskommunikation
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div>
          <h3 className="text-xl font-medium mb-3">Was ist Vibemail?</h3>
          <p className="text-gray-300 leading-relaxed">
            Vibemail ist eine innovative KI-Plattform, die speziell für Versicherungsmakler und Finanzberater entwickelt wurde. 
            Unser Ziel ist es, Ihre Kommunikation mit Kunden effizienter, professioneller und wirkungsvoller zu gestalten.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-3">Hauptfunktionen</h3>
          <ul className="space-y-3 text-gray-300">
            <li className="flex items-start">
              <div className="bg-jade/10 p-1 rounded-full mt-1 mr-3">
                <Mail className="h-4 w-4 text-jade" />
              </div>
              <div>
                <span className="font-medium text-white">KI-gestützte E-Mail-Vorlagen</span>
                <p className="text-sm text-gray-400 mt-1">Erstellen Sie professionelle E-Mail-Vorlagen für verschiedene Anlässe mit einfachen Prompts.</p>
              </div>
            </li>
            <li className="flex items-start">
              <div className="bg-jade/10 p-1 rounded-full mt-1 mr-3">
                <FileText className="h-4 w-4 text-jade" />
              </div>
              <div>
                <span className="font-medium text-white">Versicherungsdokumentenanalyse</span>
                <p className="text-sm text-gray-400 mt-1">Laden Sie Versicherungsdokumente hoch und erhalten Sie KI-gestützte Zusammenfassungen und Vergleiche.</p>
              </div>
            </li>
            <li className="flex items-start">
              <div className="bg-jade/10 p-1 rounded-full mt-1 mr-3">
                <FileCheck className="h-4 w-4 text-jade" />
              </div>
              <div>
                <span className="font-medium text-white">Angebotserstellung</span>
                <p className="text-sm text-gray-400 mt-1">Erstellen Sie professionelle Angebote und Vergleiche für Ihre Kunden.</p>
              </div>
            </li>
            <li className="flex items-start">
              <div className="bg-jade/10 p-1 rounded-full mt-1 mr-3">
                <Fingerprint className="h-4 w-4 text-jade" />
              </div>
              <div>
                <span className="font-medium text-white">Digitale Signaturfunktion</span>
                <p className="text-sm text-gray-400 mt-1">Senden Sie Dokumente zur digitalen Unterzeichnung an Ihre Kunden.</p>
              </div>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-medium mb-3">Erste Schritte</h3>
          <ol className="space-y-4 text-gray-300">
            <li className="flex items-center gap-2">
              <div className="bg-gray-700 rounded-full h-6 w-6 flex items-center justify-center text-xs text-white">1</div>
              <span>Melden Sie sich mit Ihren Zugangsdaten an oder erstellen Sie ein neues Konto.</span>
            </li>
            <li className="flex items-center gap-2">
              <div className="bg-gray-700 rounded-full h-6 w-6 flex items-center justify-center text-xs text-white">2</div>
              <span>Geben Sie einen Prompt auf der Startseite ein, um Ihre erste E-Mail-Vorlage zu erstellen.</span>
            </li>
            <li className="flex items-center gap-2">
              <div className="bg-gray-700 rounded-full h-6 w-6 flex items-center justify-center text-xs text-white">3</div>
              <span>Experimentieren Sie mit verschiedenen Kategorien und Prompts, um die besten Ergebnisse zu erzielen.</span>
            </li>
            <li className="flex items-center gap-2">
              <div className="bg-gray-700 rounded-full h-6 w-6 flex items-center justify-center text-xs text-white">4</div>
              <span>Nutzen Sie die Dokument-Upload-Funktion, um Versicherungsdokumente analysieren zu lassen.</span>
            </li>
          </ol>
        </div>
      </CardContent>
    </Card>
  );
};
